import { ComponentType } from 'react'

import { FakeDoorType } from '../types'
import { BankNoteWorldCupSearch } from './bank-note-world-cup-search'
import { UnsupportedFakeDoor } from './unsupported-fake-door'

export const fakeDoorViews: Record<FakeDoorType, ComponentType> = {
  [FakeDoorType.WORLD_CUP]: BankNoteWorldCupSearch,
  [FakeDoorType.UNSUPPORTED]: UnsupportedFakeDoor,
}
